module.exports = __webpack_public_path__ + "static/img/wheel-pointer.c4c44ed0.png";